import { render, staticRenderFns } from "./newMemberApply.vue?vue&type=template&id=389c44d0&scoped=true"
import script from "./newMemberApply.vue?vue&type=script&lang=js"
export * from "./newMemberApply.vue?vue&type=script&lang=js"
import style0 from "./newMemberApply.vue?vue&type=style&index=0&id=389c44d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389c44d0",
  null
  
)

export default component.exports